import { render } from "./ComplainListItem.vue?vue&type=template&id=1e2345aa&scoped=true"
import script from "./ComplainListItem.vue?vue&type=script&lang=js"
export * from "./ComplainListItem.vue?vue&type=script&lang=js"

import "./ComplainListItem.vue?vue&type=style&index=0&id=1e2345aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2345aa"]])

export default __exports__